import { render, staticRenderFns } from "./MarkResponseList.vue?vue&type=template&id=9455e546&scoped=true"
import script from "./MarkResponseList.vue?vue&type=script&lang=js"
export * from "./MarkResponseList.vue?vue&type=script&lang=js"
import style0 from "./MarkResponseList.vue?vue&type=style&index=0&id=9455e546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9455e546",
  null
  
)

export default component.exports